import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'api';
import { PersonalDevelopmentPlan } from 'types/pdp';
import { API_PDP_DETAIL } from 'constants/api';
import { generateURL } from 'helpers';

export const getPDP = createAsyncThunk<PersonalDevelopmentPlan, { id: number }>(
  'pdp/getPDP',
  async ({ id }, { rejectWithValue }) =>
    api.axios
      .get(generateURL(API_PDP_DETAIL, { id }))
      .then((res) => res.data)
      .catch((e) => rejectWithValue(e.response?.data)),
);
